import './Other.scss';
import { useState } from 'react';
import Aries from '../../assets/aries.png';
import aquarius from '../../assets/aquarius.png';
import cancer from '../../assets/cancer.png';
import capricorn from '../../assets/capricorn.png';
import gemini from '../../assets/gemini.png';
import leo from '../../assets/leo.png';
import libra from '../../assets/libra.png';
import pisces from '../../assets/pisces.png';
import sagittarius from '../../assets/sagittarius.png';
import scorpio from '../../assets/scorpio.png';
import taurus from '../../assets/taurus.png';
import virgo from '../../assets/virgo.png';

const Other = () => {
  const [showAll, setShowAll] = useState(false);

  return (
    <div className="other-details">
      

      <div className="heading">
        <h3>What the stars say about Weekly Horoscope</h3>
      </div>

      <div className="details-grid" id='others'>
        <div className="detail-card">
          <img src={Aries} alt="Aries" />
          <h3>Aries (March 21 - April 19)</h3>
          <p>This week brings a mix of strong passion and thoughtful introspection in your love life. With Mars intensifying emotions and Venus emphasizing emotional security, you may find yourself wanting excitement along with emotional stability.

Singles could feel drawn to someone from the past or sense familiarity in a new connection. For couples, deeper emotional bonding is favored—small, sincere actions and open conversations will strengthen relationships.

On the financial front, Mercury helps clear uncertainty, allowing you to take confident and well-planned decisions. A delayed payment or expected money may finally come through, reducing pressure.

Those working independently or running businesses may notice gradual growth. Networking can open doors, but be sure to review partnership terms carefully.

Career efforts start showing results. Recognition may come, along with added responsibility—handle it with composed leadership.

Navigate team dynamics diplomatically. Innovative thinking will help resolve challenges.

In studies, experimenting with new learning techniques can break monotony. Progress may be slow but consistent. Physically you feel active, but emotional grounding is important.

Simple routines and creative self-expression will help you stay balanced.</p>
        </div>

        <div className="detail-card">
          <img src={taurus} alt="Taurus" />
          <h3>Taurus (April 20 - May 20)</h3>
          <p>This week marks a quiet yet meaningful shift in your emotional world. Whether you’re rebuilding trust in a current relationship or opening your heart to someone new, you’re learning to trust on a deeper level.

The energy supports reflection and sincere conversations, where listening matters more than speaking. Singles are encouraged to seek authentic, emotionally fulfilling connections.

A heartfelt discussion may resolve old misunderstandings, supporting steady emotional growth. Financially, you remain cautious and practical.

Saturn strengthens your focus on long-term stability. Avoid rushing into major purchases; small, mindful financial adjustments will prove beneficial over time.

At work, step into leadership roles calmly and confidently, but don’t overextend yourself. Delayed feedback can be used to fine-tune your performance.

In education, planning and structure bring success—seeking guidance is helpful. Health-wise, pay attention to your body and stay adaptable, as balance is essential this week.</p>
        </div>

        <div className="detail-card">
          <img src={gemini} alt="Gemini" />
          <h3>Gemini (May 21 - June 20)</h3>
          <p>With Mercury and Venus supporting you, communication becomes your greatest strength this week. In love, honest discussions can clear confusion and bring emotional closeness.

Speak truthfully but gently. Singles may be drawn to someone intelligent and engaging—let meaningful conversations guide the bond.

Financially, Mars advises caution, as unexpected expenses—especially related to travel or home—may arise. Stick to a planned budget and avoid impulsive spending.

This is a good time to plan future income strategies rather than taking risks. At work, things may feel scattered, but your words have influence.

Use communication wisely in meetings, presentations, and networking. Stay realistic in commitments.

Students benefit from reducing distractions and focusing deeply. Curiosity works best when paired with discipline.

Energy levels may fluctuate, so balance rest and activity. Eat well, slow down when needed, and avoid burnout.

Consistency brings success this week.</p>
        </div>

        <div className="detail-card">
          <img src={aquarius} alt="Aquarius" />
          <h3>Aquarius (January 20 - February 18)</h3>
          <p>This week starts with emotional intensity as past feelings resurface. Use this as a chance for healing rather than dwelling.

Venus supports emotional honesty in love. Singles may feel drawn to familiar energies, while couples reconnect through shared vision.

Minor disagreements may arise, but Mercury helps resolve them through calm communication.

Financial matters require patience. Saturn encourages long-term planning, while Mars supports proactive budgeting.

Avoid risky spending. Reviewing savings and financial goals is beneficial.

At work, confidence and leadership stand out. Fresh ideas gain attention.

Old habits are ready to be transformed. Balance learning with rest, and prioritize mental well-being.</p>
        </div>

        <div className="detail-card">
          <img src={cancer} alt="Cancer" />
          <h3>Cancer (June 21 - July 22)</h3>
          <p>The week begins on a reflective note in your love life, influenced by the Moon and Venus. You may feel drawn inward, seeking emotional clarity.

In relationships, quiet acts of care speak louder than words. Singles may notice attraction toward someone emotionally mature and steady.

Trust your intuition, but avoid rushing emotional decisions. Connections are developing gradually—allow them space to grow.

Honest emotional expression brings comfort and closeness. By midweek, Jupiter supports wiser financial planning.

You may review budgets and focus on long-term security. A small opportunity, possibly through a friend, could arise—stay observant.

If self-employed, progress is steady. Avoid spending driven by stress or emotion.

Career efforts are gaining attention. A new responsibility may come your way—trust your instincts and delegate when required.

Academically, early-week focus helps clear confusion. Health improves when you listen to your body.

Rest early, stay active midweek, and emotionally recharge by the weekend.</p>
        </div>

        <div className="detail-card">
          <img src={capricorn} alt="Capricorn" />
          <h3>Capricorn (December 22 - January 19)</h3>
          <p>The Moon heightens emotional awareness this week, encouraging reflection on relationship dynamics. Honest conversations help heal unresolved issues.

Singles may feel drawn to someone dependable and value-oriented. Trust intuition over appearances.

Midweek brings financial clarity, as delayed matters begin to move forward. Transparency is important in shared finances.

A new income idea may emerge—approach it practically. At work, Mars fuels determination and leadership.

Resolve pending issues and guide teams with flexibility.

Academically, structured planning supports success. Health benefits from mindful breaks and body awareness.

Balancing productivity with rest protects long-term energy.</p>
        </div>

        {showAll && (
          <>
            <div className="detail-card">
              <img src={leo} alt="Leo" />
              <h3>Leo (July 23 - August 22)</h3>
              <p>This week encourages a softer, more inward approach to love. Rather than seeking excitement, you’ll value emotional depth and sincerity.

Couples strengthen bonds through quiet understanding and honest conversations. Singles may feel drawn to someone grounded and genuine, possibly someone previously unnoticed.

Midweek brings financial clarity as Mercury highlights areas where small adjustments can improve comfort. A minor gain from creative or side work is possible.

Avoid large loans or lending, as circumstances may shift unexpectedly.

Professionally, the Sun favors slow and steady progress. Revisiting old plans and resolving unfinished tasks earns respect from seniors.

Patience now lays the foundation for lasting success. The North Node supports learning, innovation, and leadership through collaboration.

The South Node emphasizes emotional well-being and disciplined self-care. By the weekend, renewed clarity helps align your actions with long-term personal and professional goals.</p>
            </div>

            <div className="detail-card">
              <img src={libra} alt="Libra" />
              <h3>Libra (September 23 - October 22)</h3>
              <p>Early in the week, Mercury may cause misunderstandings in close relationships. Patience is key—clear communication will prevent unnecessary tension.

Singles may attract attention, but mixed signals call for observation rather than assumption. Let actions reveal intentions.

By midweek, Venus supports financial discussions involving shared resources, planning, or agreements. Review details carefully.

Unexpected expenses may arise, so flexibility helps. Creative ideas related to income are worth exploring.

Later in the week, Mars encourages new approaches at work. Stepping away from routine can lead to fresh solutions.

Trust your instincts when opportunities appear. The South Node supports releasing outdated beliefs.

Hands-on learning brings strong progress. Balance activity with rest to maintain physical well-being.</p>
            </div>

            <div className="detail-card">
              <img src={pisces} alt="Pisces" />
              <h3>Pisces (February 19 - March 20)</h3>
              <p>The Moon heightens emotional sensitivity, helping you sense subtle shifts in relationships. Venus deepens romantic intuition, but clear communication is essential.

Revisit shared goals in relationships. Singles may feel drawn to emotionally and creatively expressive individuals.

The North Node advises staying grounded while seeking meaningful connections. Financially, Jupiter favors creative and entrepreneurial efforts.

Small gains are possible early in the week. Midweek discussions around collaborations require careful review.

Saturn supports disciplined spending. Career demands flexibility as responsibilities increase.

Unexpected opportunities may appear—evaluate them thoughtfully. Learning blends creativity with focus.

Physically and emotionally, prioritize rest, balanced nutrition, and regular self-check-ins.</p>
            </div>

            <div className="detail-card">
              <img src={sagittarius} alt="Sagittarius" />
              <h3>Sagittarius (November 22 - December 21)</h3>
              <p>This week highlights emotional expression and deeper connections. With Venus and Mercury aligned, you communicate feelings more openly and effectively.

In relationships, shared goals and thoughtful gestures reignite closeness. Singles attract attention easily but should assess intentions carefully.

Saturn urges financial discipline—review commitments, clear pending dues, and avoid overextending yourself.

Steady effort brings real rewards. Professionally, your consistent work begins to gain recognition.

Mars boosts ambition, but avoid rushing changes. Leadership roles may arise along with increased responsibility.

In learning and health, experimenting with new methods brings positive results. Respect your need for rest and calm.

Growth comes from balance and steady pacing.</p>
            </div>

            <div className="detail-card">
              <img src={scorpio} alt="scorpio" />
              <h3>Scorpio (October 23 - November 21)</h3>
              <p>This week brings heightened emotions and strong desires in love, guided by the Moon and Mars. Relationships deepen through emotional and physical closeness, but mindful communication is essential.

Singles may experience intense attractions, but emotional authenticity matters more than surface chemistry. Release old expectations to welcome healthier connections.

Midweek favors finances, with possible recognition or income linked to career efforts. Manage money wisely and avoid risky joint investments.

Review financial plans carefully and stay grounded in decisions.

At work, the South Node encourages observation rather than confrontation. Avoid unnecessary conflicts.

Opportunities may come through mentors or past contacts. Focus on quality over quantity.

Academically, focus and clarity are strong. Health improves with steady routines, gentle exercise, and immune support.

Balance remains your key strength.</p>
            </div>

            <div className="detail-card">
              <img src={virgo} alt="virgo" />
              <h3>Virgo (August 23 - September 22)</h3>
              <p>Venus enhances your warmth and charm this week, making relationships feel lighter and more open. Couples can reignite closeness through thoughtful gestures, while singles may see casual conversations deepen naturally.

Being genuine and emotionally open attracts positive attention. By midweek, Mercury and Jupiter support financial improvement through learning, communication, or networking.

New income ideas may emerge through discussions or skill-building. Avoid major purchases and focus on clearing smaller dues.

Negotiations around salary or contracts may arise—prepare well and recognize your worth. Later in the week, Mars boosts motivation at work.

You’ll feel driven to refine strategies and face challenges. Entrepreneurs benefit from subtle improvements in presentation or branding.

Avoid overcommitting. Prioritization and discipline support success in both studies and health.

Consistent routines help maintain energy and emotional calm throughout the week.</p>
            </div>
          </>
        )}
      </div>

      <button onClick={() => setShowAll(!showAll)}>
        {showAll ? "Show Less" : "More Signs"}
      </button>

      <div className="stats">
        <div className="stat-card">
          <span>PARTNER</span>
          <h2>10+</h2>
        </div>
        <div className="stat-card">
          <span>TEAMS</span>
          <h2>30+</h2>
        </div>
        <div className="stat-card">
          <span>HAPPY CLIENT</span>
          <h2>10K+</h2>
        </div>
        <div className="stat-card">
          <span>SERVICED</span>
          <h2>16K+</h2>
        </div>
      </div>
    </div>
  );
};

export default Other;
